const doc = [({"da":({"js":({"admin":({"employee_prices":({"table":({"the_employee_price_was_deleted":"Medarbejderens priser for perioden blev slettet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;